<template>
    <h2
        class="mb-5 whitespace-pre-line text-pretty px-2 text-[1.5rem] font-bold leading-[1.3] sm:px-5 sm:text-[1.75rem] lg:text-[2rem]"
    >
        <slot />
    </h2>
</template>
